'use client';

import SearchTrigger from '@components/search/SearchTrigger';
import { NavMain } from '@components/nav-main';
import { NavSecondary } from '@components/nav-secondary';
import { SidebarContent } from '@components/ui/sidebar';
import { getRouteItems, ROUTE } from '@utils/route-utils';
import { useTranslations } from 'next-intl';

type AppSidebarContentProps = {
  organization_id: string;
};

export default function AppSidebarContent({
  organization_id
}: AppSidebarContentProps) {
  const t = useTranslations();
  const routeItems = getRouteItems(organization_id, t);

  return (
    <SidebarContent>
      <SearchTrigger
        renderLabel
        className="mx-2 flex min-h-11 items-center gap-3 rounded-xl px-3 text-body text-muted-foreground hover:bg-accent"
      />
      <NavMain organization_id={organization_id} />
      <NavSecondary item={routeItems[ROUTE.LIBRARY]} />
      <NavSecondary item={routeItems[ROUTE.TEAM]} />
      <NavSecondary item={routeItems[ROUTE.UTILITIES]} className="mt-auto" />
    </SidebarContent>
  );
}
